import { useCallback, useContext, useEffect, useState } from 'react';
import qs from 'qs';

import {
  getShopToken,
  getShopTokenByRefreshToken,
} from '../modules/NetworkFunction';
import ShopModeContext from '../contexts/ShopModeContext';

const useCafe24Auth = () => {
  const { shopMode } = useContext(ShopModeContext);
  const cafe24AccessToken = sessionStorage.getItem('accessToken');
  const [accessToken, setAccessToken] = useState(() => cafe24AccessToken);
  const mallId = localStorage.getItem('mallId');

  const setToken = (data) => {
    setAccessToken(data.access_token);
    sessionStorage.setItem('accessToken', data.access_token);
    sessionStorage.setItem('refreshToken', data.refresh_token);
    sessionStorage.setItem('expiredTime', data.expires_at);
    sessionStorage.setItem(
      'refreshTokenExpiredTime',
      data.refresh_token_expires_at
    );
  };

  const isTokenExpired = useCallback(() => {
    const tokenExpiredTime = new Date(sessionStorage.getItem('expiredTime'));

    if (!tokenExpiredTime) return true;

    const now = new Date();

    return now >= tokenExpiredTime;
  }, []);

  const isRefreshTokenExpired = useCallback(() => {
    const refreshTokenExpiredTime = new Date(
      sessionStorage.getItem('refreshTokenExpiredTime')
    );
    if (!refreshTokenExpiredTime) return true;

    const now = new Date();

    return now >= refreshTokenExpiredTime;
  }, []);

  const setCafe24AccessToken = useCallback((mallId, redirectURI) => {
    if (!mallId) return;

    const authQuery = qs.stringify({
      response_type: 'code',
      client_id: process.env.REACT_APP_CAFE24_CLIENT_ID,
      state: 'authcode',
      redirect_uri: redirectURI,
      scope:
        'mall.read_product,mall.write_product,mall.read_store,mall.write_application,mall.read_application,mall.read_design,mall.read_category,mall.write_category',
    });

    const loginUrl = `https://${mallId}.cafe24api.com/api/v2/oauth/authorize?${authQuery}`;

    const query = window.location.search;
    const params = new URLSearchParams(query);
    let authCode = params.get('code');
    if (!authCode) window.location.assign(loginUrl);

    if (authCode) {
      getShopToken(
        { code: authCode, mallId: mallId, redirectURI },
        (data) => {
          setToken(data);
          sessionStorage.setItem('modalOpen', 'true');
          window.history.replaceState({}, null, redirectURI);
        },
        () => {},
        (e) => {
          alert('연동에 실패했습니다. 다시 시도해주세요.');
          window.location.assign(loginUrl);
        },
        null
      );
    }
  }, []);

  const setRefreshToken = useCallback((mallId) => {
    sessionStorage.removeItem('accessToken');

    if (!mallId) return;
    getShopTokenByRefreshToken(
      {
        refreshToken: sessionStorage.getItem('refreshToken'),
        mallId: mallId,
      },
      (data) => {
        setToken(data);
      },
      () => {},
      (e) => {
        alert('연동에 실패했습니다. 다시 시도해주세요.');
      },
      null
    );
  }, []);

  useEffect(() => {
    if (shopMode === 'cafe24' && accessToken && cafe24AccessToken && mallId) {
      if (isTokenExpired()) {
        if (isRefreshTokenExpired()) {
          alert('카페24 토큰이 만료되었습니다. 다시 시도해주세요.');
          sessionStorage.removeItem('accessToken');
          setCafe24AccessToken(
            mallId,
            window.location.origin + '/mypage/setting'
          );
        } else {
          setRefreshToken(mallId);
        }
      }
    }
  }, [
    shopMode,
    accessToken,
    cafe24AccessToken,
    mallId,
    isRefreshTokenExpired,
    isTokenExpired,
    setCafe24AccessToken,
    setRefreshToken,
  ]);

  return {
    isTokenExpired,
    isRefreshTokenExpired,
    setCafe24AccessToken,
    setRefreshToken,
    setAccessToken,
    accessToken,
  };
};

export default useCafe24Auth;

